import { render, staticRenderFns } from "./MasterSummary.vue?vue&type=template&id=27523be3"
import script from "./MasterSummary.vue?vue&type=script&lang=js"
export * from "./MasterSummary.vue?vue&type=script&lang=js"
import style0 from "./MasterSummary.vue?vue&type=style&index=0&id=27523be3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports